
import _ from 'lodash';

import APP_CONFIG from '../app.config';

const MAPS_URL = 'https://maps.googleapis.com/maps/api/js';

/**
 * URL for Google Maps search, use this to open new pages with GMaps pointing to given address.
 *
 * See this for arguments: https://developers.google.com/maps/documentation/urls/guide#search-action
 *
 * @type {string}
 */
const MAPS_SEARCH_URL = 'https://www.google.com/maps/search/';

class GaMapsService {
  constructor($compile, $timeout, $q, $httpParamSerializer) {
    'ngInject';

    this.$compile = $compile;
    this.$timeout = $timeout;
    this.$q = $q;
    this.$httpParamSerializer = $httpParamSerializer;

    this.gaMaps = APP_CONFIG.gaMaps;
  }

  /**
   * Get google maps library.
   *
   * @returns {Promise} Promise that is resolved with google maps <code>google.maps</code> object.
   */
  map() {
    return this.$q(resolve => {
      const params = {
        v: 3,
        callback: 'mapsLoadCallback'
      };

      if (this.gaMaps != null && this.gaMaps !== '') {
        params.key = this.gaMaps;
      }

      if (_.isUndefined(window.google) || _.isUndefined(window.google.maps)) {
        window.mapsLoadCallback = () => {
          this.$timeout(() => {
            // Run in timeout to allow maps to load first
            resolve(window.google.maps);
          }, 10);
        };

        const scriptEl = document.createElement('script');
        scriptEl.src = `${MAPS_URL}?${this.$httpParamSerializer(params)}`;

        if (!document.querySelector(`script[src="${scriptEl.src}"]`)) {
          document.body.appendChild(scriptEl);
        }
      }
      else {
        resolve(window.google.maps);
      }
    });
  }

  /**
   * Return link to external Google Maps pointing at the given search / place
   * @param {string} search Place to search for. Recommended to give this even if place ID exists
   * @param {string} place_id Place ID to point at, this should be used if possible
   */
  externalMapLink(search, place_id='') {
    const params = Object.assign({api: 1}, {query: search, query_place_id: place_id});
    return `${MAPS_SEARCH_URL}?${this.$httpParamSerializer(params)}`;
  }
}

const mod = angular.module('app.gamaps.service', [])

.service('GaMaps', GaMapsService);

export default mod.name;
